import React from 'react';
import { func, bool } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SnackBar from '../SnackBar';

export default class OrderSoundNotification extends React.Component {
  static propTypes = {
    onSoundWarningDismissed: func,
    hasUserInteractedWithPage: bool.isRequired,
  };

  static defaultProps = {
    onSoundWarningDismissed: Function.prototype,
  };

  componentDidMount() {
    if (!this.props.hasUserInteractedWithPage) {
      window.addEventListener('click', this.closeSoundWarning);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.closeSoundWarning);
  }

  closeSoundWarning = () => {
    const { onSoundWarningDismissed } = this.props;
    onSoundWarningDismissed();
    window.removeEventListener('click', this.closeSoundWarning);
  };

  render() {
    return (
      <SnackBar>
        <FormattedMessage
          id="order_sound.disabled"
          defaultMessage="Your sound is inactive, click here to enable"
        />
      </SnackBar>
    );
  }
}



// WEBPACK FOOTER //
// ../ui-components/components/OrderSoundNotification/index.jsx